/* R44 — My Garage funnel tracking (GA4 + Shopify customer events). Counts every visitor, signed in or not.
   Events (GA4 → Reports → Engagement → Events, or Explore → Funnel exploration):
     r44_garage_open           pop-out garage opened
     r44_garage_add_start      "Add a vehicle" clicked in the pop-out
     r44_garage_car_chosen     year, make and model all picked (pop-out, homepage My Garage or vehicle page)
     r44_garage_save_click     "Add to garage" / save clicked
     r44_garage_email_shown    email step shown (visitor not known yet)
     r44_garage_email_submit   email entered and submitted
     r44_garage_email_success  email accepted, car saved
     r44_garage_email_error    email step failed (Klaviyo error or invalid email)
     r44_garage_email_cancel   email step cancelled
     r44_garage_car_saved      a new car appeared in the garage
   Parameters: garage_source (popout / homepage / vehicle_page / other), visitor (signed_in / known / new_signup / anonymous),
   vehicle_make, vehicle_model, vehicle_year, garage_size, page_path.
   Add ?r44_ga_debug=1 to any URL to log events in the browser console.
   Loaded from snippets/r44-klaviyo-garage.liquid (data-ga = GA4 measurement ID, data-customer = signed in). */
(function () {
  'use strict';
  var cfg = (document.currentScript && document.currentScript.dataset) || {};
  var GA = cfg.ga || '';
  var CUSTOMER = cfg.customer === '1';
  var ES_KEY = 'easysearch-garage-items', ES_DELIM = 'easysearch-preselect-delimiter';
  var SEEN_KEY = 'r44-ga-garage-seen';
  var debug = false;
  try {
    if (/[?&]r44_ga_debug=1/.test(location.search)) sessionStorage.setItem('r44-ga-debug', '1');
    if (/[?&]r44_ga_debug=0/.test(location.search)) sessionStorage.removeItem('r44-ga-debug');
    debug = sessionStorage.getItem('r44-ga-debug') === '1';
  } catch (e) {}

  function getLS(k) { try { return localStorage.getItem(k); } catch (e) { return null; } }
  function setLS(k, v) { try { localStorage.setItem(k, v); } catch (e) {} }
  function getSS(k) { try { return sessionStorage.getItem(k); } catch (e) { return null; } }
  function setSS(k, v) { try { sessionStorage.setItem(k, v); } catch (e) {} }

  // Is Klaviyo already aware of this visitor? (checked in the background)
  var klaviyoKnown = false;
  (function check(n) {
    var k = window.klaviyo;
    if (k && typeof k.isIdentified === 'function') {
      Promise.resolve(k.isIdentified()).then(function (v) { klaviyoKnown = v === true; }, function () {});
    } else if (n < 40) { setTimeout(function () { check(n + 1); }, 250); }
  })(0);
  function visitor() {
    if (CUSTOMER) return 'signed_in';
    var t = parseInt(getSS('r44-ga-email-ok') || '0', 10);
    if (t && Date.now() - t < 10 * 60 * 1000) return 'new_signup';
    return klaviyoKnown ? 'known' : 'anonymous';
  }

  var lastSource = getSS('r44-ga-source') || '';
  function sourceOf(el) {
    if (!el || !el.closest) return 'other';
    if (el.closest('.easysearch-garage-widget')) return 'popout';
    if (el.closest('.r44mg-es, [id*="r44_my_garage"], .r44mg')) return 'homepage';
    if (el.closest('.r44vg-es, .r44vh, [class*="r44vh"]')) return 'vehicle_page';
    return 'other';
  }
  function remember(src) { lastSource = src; setSS('r44-ga-source', src); }

  function track(name, params) {
    params = params || {};
    params.page_path = location.pathname;
    if (!params.visitor) params.visitor = visitor();
    try { if (typeof window.gtag === 'function') window.gtag('event', name, GA ? Object.assign({ send_to: GA }, params) : params); } catch (e) {}
    try { if (window.Shopify && Shopify.analytics && typeof Shopify.analytics.publish === 'function') Shopify.analytics.publish(name, params); } catch (e) {}
    if (debug && window.console) console.log('[R44 garage analytics]', name, params);
  }

  function carFrom(scope) {
    var sels = scope ? scope.querySelectorAll('.easysearch-field-select-holder select') : [], v = [];
    for (var i = 0; i < sels.length; i++) {
      if (!sels[i].value) return null;
      v.push(((sels[i].options[sels[i].selectedIndex] || {}).text || sels[i].value).trim());
    }
    return v.length >= 3 ? { vehicle_year: v[0], vehicle_make: v[1], vehicle_model: v[v.length - 1] } : null;
  }
  function scopeOf(el) { return el.closest('.easysearch-garage-select-wrapper, .easysearch-widget, .easysearch-embed-widget-main') || el.closest('form') || document; }

  // 1) Pop-out opened
  var wasOpen = false;
  function watchWidget() {
    var w = document.querySelector('.easysearch-garage-widget');
    if (!w || w.__r44ga) return;
    w.__r44ga = true;
    new MutationObserver(function () {
      var open = w.classList.contains('easysearch-garage-opened');
      if (open && !wasOpen) { remember('popout'); track('r44_garage_open', { garage_source: 'popout' }); }
      wasOpen = open;
    }).observe(w, { attributes: true, attributeFilter: ['class'] });
  }
  watchWidget();
  setInterval(watchWidget, 1500);

  // 2) Clicks: add a vehicle, save, email cancel
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var btn = t.closest('a, button');
    if (!btn) return;
    var txt = (btn.textContent || '').trim().toLowerCase();
    var src = sourceOf(btn);
    if (btn.hasAttribute('data-r44pg-cancel')) { track('r44_garage_email_cancel', { garage_source: src }); return; }
    if (src === 'popout' && /add a vehicle|add vehicle/.test(txt) && !btn.classList.contains('easysearch-btn-search')) {
      track('r44_garage_add_start', { garage_source: 'popout' }); return;
    }
    var isSave = btn.classList.contains('easysearch-btn-garage') || (src === 'popout' && btn.classList.contains('easysearch-btn-search')) || /add to garage|save vehicle/.test(txt);
    if (isSave && !btn.classList.contains('r44pg__btn')) {
      remember(src);
      var car = carFrom(scopeOf(btn)) || {};
      track('r44_garage_save_click', Object.assign({ garage_source: src }, car));
    }
  }, true);

  // 3) Year / make / model all chosen
  var lastChosen = '';
  document.addEventListener('change', function (e) {
    var s = e.target;
    if (!s || s.tagName !== 'SELECT' || !s.closest('.easysearch-field-select-holder')) return;
    var car = carFrom(scopeOf(s));
    if (!car) return;
    var src = sourceOf(s), key = src + '|' + car.vehicle_year + car.vehicle_make + car.vehicle_model;
    if (key === lastChosen) return;
    lastChosen = key;
    remember(src);
    track('r44_garage_car_chosen', Object.assign({ garage_source: src }, car));
  }, true);

  // 4) Email step (pop-out gate and homepage My Garage signup forms)
  function watchGates() {
    [].slice.call(document.querySelectorAll('.r44pg')).forEach(function (g) {
      if (g.__r44ga) return;
      g.__r44ga = true;
      var visible = false;
      new MutationObserver(function () {
        var v = !g.hidden;
        if (v && !visible) {
          var car = carFrom(scopeOf(g)) || {};
          track('r44_garage_email_shown', Object.assign({ garage_source: sourceOf(g), visitor: 'anonymous' }, car));
        }
        visible = v;
        var msg = g.querySelector('[data-r44pg-msg]');
        if (msg && !msg.hidden && !msg.__r44done) {
          if (msg.classList.contains('is-success')) { msg.__r44done = true; setSS('r44-ga-email-ok', String(Date.now())); track('r44_garage_email_success', { garage_source: sourceOf(g), visitor: 'new_signup' }); }
          else if (msg.classList.contains('is-error')) { track('r44_garage_email_error', { garage_source: sourceOf(g), visitor: 'anonymous', error: (msg.textContent || '').slice(0, 80) }); }
        }
        if (msg && msg.hidden) msg.__r44done = false;
      }).observe(g, { attributes: true, subtree: true, childList: true, characterData: true, attributeFilter: ['hidden', 'class'] });
    });
  }
  watchGates();
  setInterval(watchGates, 1500);
  document.addEventListener('submit', function (e) {
    var f = e.target;
    if (!f || !f.closest) return;
    if (f.closest('.r44pg')) { track('r44_garage_email_submit', { garage_source: sourceOf(f), visitor: 'anonymous' }); return; }
    var sec = f.closest('.r44mg, [class*="r44mg"]');
    if (sec && f.querySelector('input[type="email"]')) {
      setSS('r44-ga-email-ok', String(Date.now()));
      track('r44_garage_email_submit', { garage_source: 'homepage', visitor: 'anonymous' });
    }
  }, true);

  // 5) New car in the garage (whatever saved it). Cars already there on the first visit aren't counted.
  function labels() {
    var list = [];
    try { var raw = JSON.parse(getLS(ES_KEY) || 'null'); list = raw && raw.value ? raw.value : (Array.isArray(raw) ? raw : []); } catch (e) {}
    return list.map(function (x) { return String(x).split(ES_DELIM).map(function (p) { return p.trim(); }).filter(Boolean).join(' '); }).filter(Boolean);
  }
  var seenRaw = getLS(SEEN_KEY);
  if (seenRaw === null) setLS(SEEN_KEY, JSON.stringify(labels()));
  function checkSaved() {
    var now = labels(), seen = [];
    try { seen = JSON.parse(getLS(SEEN_KEY) || '[]'); } catch (e) {}
    var added = now.filter(function (l) { return seen.indexOf(l) === -1; });
    if (!added.length) { if (now.length !== seen.length) setLS(SEEN_KEY, JSON.stringify(now)); return; }
    setLS(SEEN_KEY, JSON.stringify(now));
    added.forEach(function (l) {
      var p = l.split(' ');
      track('r44_garage_car_saved', { garage_source: lastSource || 'other', vehicle_year: p[0], vehicle_make: p[1], vehicle_model: p.slice(2).join(' '), garage_size: now.length });
    });
  }
  setInterval(checkSaved, 2000);
  window.addEventListener('storage', function (e) { if (e.key === ES_KEY) checkSaved(); });
})();
